import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkProps"];
import React from "react";
import Avatar from "./Avatar";
import { BaseAvatarLink } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function AvatarLink(_ref) {
  var linkProps = _ref.linkProps,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseAvatarLink, _extends({}, linkProps, {
    children: /*#__PURE__*/_jsx(Avatar, _extends({}, restProps))
  }));
}
export default AvatarLink;